module.exports = __webpack_public_path__ + "static/img/design.24cfc5a6.svg";